import { useEffect } from "react";
import { servers as serversList } from "@/server/crons/server-monitoring/servers";

type MockStatus = {
  status: string;
  responseTime: string;
  uptime: string;
  color: string;
  bgColorStyle: string;
};

const statusOptions = [
  { status: "online", responseTime: "45ms", uptime: "99.9%", color: "bg-green-500", bgColorStyle: "rgba(34, 197, 94, 0.2)" },
  { status: "warning", responseTime: "320ms", uptime: "98.2%", color: "bg-yellow-500", bgColorStyle: "rgba(234, 179, 8, 0.2)" },
  { status: "offline", responseTime: "N/A", uptime: "45.1%", color: "bg-red-500", bgColorStyle: "rgba(239, 68, 68, 0.2)" },
];

export function useStatusRandomizer(
  intervalSeconds: number | undefined,
  setMockStatuses: React.Dispatch<React.SetStateAction<Record<string, MockStatus>>>
) {
  useEffect(() => {
    if (!intervalSeconds || intervalSeconds <= 0) return;

    const interval = setInterval(() => {
      const serverNames = Object.entries(serversList)
        .filter(([_, config]) => !config.silent)
        .map(([name]) => name);
      const randomServer = serverNames[Math.floor(Math.random() * serverNames.length)];
      const randomStatus = statusOptions[Math.floor(Math.random() * statusOptions.length)];

      if (randomServer) {
        setMockStatuses((prev) => ({
          ...prev,
          [randomServer]: randomStatus,
        }));
      }
    }, intervalSeconds * 1000);

    return () => clearInterval(interval);
  }, [intervalSeconds, setMockStatuses]);
}
